import { AssessmentMode } from "./AssessmentMode";
import {BatteryStateType, ConnectionStateType,LanguageSwitchType} from '@npd-ng/adp-benchmark';
import {NetworkConnectionState, NetworkConnectionStateObj, ServerConnectionState } from "./ConnectionState";
import {Battery} from "../types/BatteryState"
import { Content } from "./Content";
import { AppConfigExtended } from "../types/Config";
import { VerifySetUpCodeResponse, assessmentLocation } from "./School";
import { ADPUpdaterMessageTypesExtended, IpcMessageType } from "./BridgeTypes";
import { StressTest} from "./StressTest";
import { DeviceReadinessInfo } from "./Device";
import { ValidationSummary} from "@npd-ng/adp-types";
import { StressSummary } from "../../Types";
import { UpdateComponents } from "../state";
export type deviceType = "SBE" | "NPE" | undefined;
export type Views = "LoadingErrroView" | "RedirectionView" | "WaitView" | "WarningView" | "LoadingView" | "ErrorView" | "UpdaterView" | "ModeSelectionsView" | "StressTestView" | "DeviceValidationView" | "SetupCodeValidationView" | "StressTestDisconnectedView" | "HardwareCheckFailureView"
export type LastKnownGoodState = "Loading" | "ModeSelection" | "StressTest" | "Update" | "DeviceValidation" | "SetupCodeValidation" | "RedirectToSCI" 
export type ValidationState = undefined | "networkConnectionValidation" | "setupCodeValidation" | "deviceValidation" 
export type ConnectionValidationTypes = "NoInternetConnectionDetected" | "NoRouterConnectionDetected" | "NoServerConnectionDetected" | "NoNCSConnectionDetected"
export type ValidationErrorTypes = ConnectionValidationTypes | "FailedHardwareCheck" | "UpdateError" | "SystemError" | "FailedSystemTimeCheck" 
| "FailedVersionCheck" | "FailedModeOneCheck" 
export type RuntimePlatform = "Electron" | "ChromeWithExtension" | "Browser";
export interface IAppState extends IADPState, IHeaderState {}
export type UpdateStates = ADPUpdaterMessageTypesExtended;
export type PreCacheVaidationStatus = {
    validationStatus: ServiceWorkerValidationType,
    validationDetails: string
}
export enum eNAEPComponents {
    ADP = "ADP",
    SCI = "SCI",
    ADC = "ADC"
}
export type ServiceWorkerValidationType = "NotStarted" | "Pending" | "InProgress" | "Complete" | "Failed" | "Skipped"
export enum ServiceWorkerMessageType {
    POLL_PRECACHE_STATE = "POLL_PRECACHE_STATE",
    PRECACHE_COMPLETE = "PRECACHE_COMPLETE",
    PRECACHE_FAILURE = "PRECACHE_FAILURE",
    GET_APPLICATION_VERSION = "GET_APPLICATION_VERSION",
    PRECACHE_NOT_COMPLETE = "PRECACHE_NOT_COMPLETE",
  }
  
export type ServiceWorkerType = {
    appCode: eNAEPComponents,
    registrationStatus?: string,
    cachedVersion?: string,
    serverVersion?: string | undefined
    serverVersionError?: string
}
export interface IHeaderState {
        batteryState: BatteryStateType,
        networkConnectionState: ConnectionStateType[],
        clockState: string,
        showBatteryWarning: boolean
        selectedLocale: LanguageSwitchType["selectedLocale"]
}

export interface IADPState {
    appState: {
        appLaunchTime: string,
        appLaunchId: string | undefined,
        appVersion: string ,
        appCode: string,
        appBuildDate: string | undefined,
        releaseVersion: string | undefined,
        releaseBuildNumber: number,
        environment: string | undefined,
        apiDomain: string,
        configuration: AppConfigExtended | undefined,
        currentView: Views,
        isPageReloaded: boolean,
        runtimePlatform: {
            platform: RuntimePlatform,
            version: string,
            userAgent: string
        },
    }, 
    serviceWorkers?:ServiceWorkerType[],
    cacheValidation:{
        validationStatus: PreCacheVaidationStatus["validationStatus"],
        validationDetails?: PreCacheVaidationStatus["validationDetails"],
        validationEvents?:PreCacheVaidationStatus[],
    },
    updateState: {
        isCheckForUpdateEnabled: boolean,
        updateEvents?: IpcMessageType,
        appComponentVersions: UpdateComponents[]
    },
    deviceState:{
        batteryState: BatteryStateType | undefined,
        battery: Battery | undefined,
        deviceId: string | undefined, 
        deviceType: deviceType,
        deviceModel: string | undefined,
        isDeviceHealthy: boolean | undefined,
        browserAgentData: any,
        systemInfo?: any
    },
    sessionState: {
        selectedLanguage: "english" | "spanish",
        selectedAssessmentMode: AssessmentMode,
        networkConnectionState: NetworkConnectionState,
        networkDetails?: NetworkConnectionStateObj,
        networkChangeEvents:NetworkConnectionStateObj[],
        serverConnectionState: ServerConnectionState,
        schoolDetails: VerifySetUpCodeResponse | undefined,
        lastKnownGoodState: Views,
        providedSetupCode:string | undefined,
        selectedAssessmentLocation: assessmentLocation | undefined,
        locationError:boolean
    },
    deviceReadinessState: {
        validationState: ValidationState,
        validationError: ValidationErrorTypes | undefined,
        deviceReadinessInfo?: DeviceReadinessInfo
        },
    deviceReadinessSummary: ValidationSummary | undefined,
    networkReadinessState: {
        isRequired: boolean | undefined,
        executionState: StressTest,
        stressTestSummary?: StressSummary
    },
    connectedNCSState?: {
        isHealthy: boolean;
        ncsAppVersion: string;
        eNAEPVersion: string;
        eNAEPVersionStudentApp: string,
        environment:string,
        connectionInfo: {
          ipAddress: string;
          routerName: string;
          ncsAssetTag: string;
        };
        date: string;
        config: {
          defaultDomain: string;
          staticServices: {
            port: number;
            protocol: string;
            assessmentEntryUrl: string;
          };
          adsServices: {
            port: number;
            protocol: string;
            heartbeatUrl: string;
            heartbeatAsyncUrl: string;
            verifySetUpCodeUrl: string;
            deviceMetricsUrl: string;
            saveStateUrl: string,
            startAssessment: string,
            authenticate: string
          };
          adminServices: {
            port: number;
            protocol: string;
            dataTransferUrl: string;
          };
        };
      };
    staticContent: Content | undefined
}

